module.exports = __webpack_public_path__ + "static/media/ultra-cash.a9a642b9.png";